import React, { useState } from "react";
import "../App.css";
import { Link } from "react-scroll";
import { BsMoonFill } from "react-icons/bs";
import { HiOutlineSun } from "react-icons/hi";
import { useTranslation } from "react-i18next";

function NavbarComponent() {
  const [darkMode, setDarkMode] = useState(false);
  const [language, setLanguage] = useState("en");
  React.useEffect(() => {
    const json = localStorage.getItem("site-dark-mode");
    const currentMode = JSON.parse(json);
    if (currentMode) {
      setDarkMode(true);
    } else {
      setDarkMode(false);
    }
  }, []);

  React.useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
    const json = JSON.stringify(darkMode);
    localStorage.setItem("site-dark-mode", json);
  }, [darkMode]);
  const { t, i18n } = useTranslation();
  return (
    <nav
      className="navbar is-fixed-top has-shadow is-spaced "
      style={{ backgroundColor: "#124559" }}
      role="navigation"
      aria-label="main navigation"
      id="nv"
    >
      <div className="navbar-brand">
        <a
          className="navbar-item"
          href="/"
          style={{ fontSize: "25px", color: "#00D1B2" }}
        >
          <p className="mk"> &lt;Mk &frasl; &gt;</p>
        </a>
      </div>

      <div id="my-nav" className="navbar-menu">
        <Link activeClass="active" smooth spy to="home" className="navbar-item">
          {t("tr.home")}
        </Link>
        <Link
          activeClass="active"
          smooth
          spy
          to="about"
          className="navbar-item"
        >
          {t("tr.about")}
        </Link>

        <Link
          activeClass="active"
          smooth
          spy
          to="skills"
          className="navbar-item"
        >
          {t("tr.skills")}
        </Link>
        <Link
          activeClass="active"
          smooth
          spy
          to="projects"
          className="navbar-item"
        >
          {t("tr.projects")}
        </Link>
        <Link
          activeClass="active"
          smooth
          spy
          to="contact"
          className="navbar-item"
        >
          Contact
        </Link>
      </div>

      <div className="navbar-end is-hidden-touch">
        <button
          className="button darkModeBtn navbar-item mr-2"
          onClick={() => {
            if (language === "en") {
              i18n.changeLanguage("fr");
              setLanguage("fr");
            } else {
              i18n.changeLanguage("en");
              setLanguage("en");
            }
          }}
        >
          <span className="lang">{language.toUpperCase()}</span>
        </button>
        <button
          className="button darkModeBtn navbar-item"
          onClick={() => setDarkMode(!darkMode)}
        >
          {darkMode ? (
            <BsMoonFill size={20} color={"hsl(142, 52%, 96%)"} />
          ) : (
            <HiOutlineSun size={20} color={"#0A80B3"} />
          )}
        </button>
      </div>
    </nav>
  );
}

export default NavbarComponent;
